module.exports = __webpack_public_path__ + "img/logo.b4b586a7.png";